/* LUME Research & Journal — grid + in-page article reader (final.html) */
(function () {
  const posts = window.LUME_JOURNAL;
  if (!Array.isArray(posts) || !posts.length) return;

  const grid = document.getElementById('jrGrid');
  const list = document.getElementById('jrList');
  const article = document.getElementById('jrArticle');
  if (!grid || !list || !article) return;

  function metaLine(a) {
    return a.tag === 'Research' ? a.date : a.date + ' · ' + a.min + ' min read';
  }

  function clear(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function el(tag, className, text) {
    const n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  function buildGrid() {
    clear(grid);
    posts.forEach(function (a, i) {
      const btn = el('button', 'jr-card reveal');
      btn.type = 'button';
      btn.style.setProperty('--jc', a.color);
      btn.setAttribute('data-jr-index', String(i));
      btn.appendChild(el('span', 'jr-tag', a.tag));
      btn.appendChild(el('span', 'jr-title', a.title));
      btn.appendChild(el('span', 'jr-excerpt', a.excerpt));
      btn.appendChild(el('span', 'jr-meta', metaLine(a)));
      grid.appendChild(btn);
    });
  }

  function showJrList() {
    article.classList.remove('show');
    clear(article);
    list.hidden = false;
    list.style.display = '';
    window.scrollTo(0, 0);
  }

  function showPost(i) {
    const a = posts[i];
    if (!a) return;
    history.pushState({ lume: 'post' }, '');
    article.style.setProperty('--jc', a.color);
    clear(article);

    const back = el('button', 'jr-backlist');
    back.type = 'button';
    back.setAttribute('data-jr-back', '');
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '13');
    svg.setAttribute('height', '13');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M13 8H3M7 4l-4 4 4 4');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    back.appendChild(svg);
    back.appendChild(document.createTextNode('All articles'));
    article.appendChild(back);

    const tag = el('div', 'jr-tag', a.tag);
    tag.style.setProperty('--jc', a.color);
    article.appendChild(tag);
    article.appendChild(el('h1', null, a.title));
    article.appendChild(el('span', 'jr-meta', metaLine(a) + ' · LUME Research & Journal'));

    const body = el('div', 'jr-body');
    (a.body || []).forEach(function (par) {
      body.appendChild(el('p', null, par));
    });
    article.appendChild(body);

    list.hidden = true;
    list.style.display = 'none';
    article.classList.add('show');
    window.scrollTo(0, 0);
  }

  buildGrid();

  grid.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-jr-index]');
    if (!btn) return;
    showPost(Number(btn.getAttribute('data-jr-index')));
  });

  article.addEventListener('click', function (e) {
    if (e.target.closest('[data-jr-back]')) history.back();
  });

  window.addEventListener('popstate', function (e) {
    const s = e.state;
    if (article.classList.contains('show') && (!s || s.lume !== 'post')) {
      showJrList();
    }
  });

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    grid.querySelectorAll('.reveal').forEach(function (node) {
      io.observe(node);
    });
  } else {
    grid.querySelectorAll('.reveal').forEach(function (node) {
      node.classList.add('in');
    });
  }
})();
